const CATEGORY_LABELS = {
    conversation: "Conversation",
    message: "Message",
    note: "Note",
    contact: "Contact",
};


const CATEGORY_OPTIONS = [
    { key: "all", label: "All categories", iconClassName: "all-categories-icon" },
    ...Object.entries(CATEGORY_LABELS).map(([categoryKey, categoryValue]) => {
        return {
            key: categoryKey + "s",
            label: categoryValue + "s",
            iconClassName: `${categoryKey + "s"}-icon`,
        };
    }),
];

const EMPTY_STATE_MESSAGE = {
    all: "messages, contacts, and notes",
};

const GLOBAL_SEARCH_DEFAULT_ACTIVE_CATEGORY = "all";

const CATEGORY_ICONS_CLASSNAME = Object.fromEntries(Object.keys(CATEGORY_LABELS).map((typeLabel) => [typeLabel, `${typeLabel}-type-icon`]));

const CHANNEL_LABELS = { 1: "SMS", 2: "Messenger", 3: "WhatsApp", 4: "Voice", 5: "" };

const GLOBAL_SEARCH_RECENT_SEARCHES_KEY = "global-search-recent";
const MAX_RECENT_SEARCHES_TO_STORE_IN_THE_LOCAL_STORAGE = 5;

const GLOBAL_SEARCH_NAVIGATION_STATE_KEY = "globalSearchNavigationState";

export {
    CATEGORY_OPTIONS,
    EMPTY_STATE_MESSAGE,
    CATEGORY_LABELS,
    CATEGORY_ICONS_CLASSNAME,
    CHANNEL_LABELS,
    GLOBAL_SEARCH_RECENT_SEARCHES_KEY,
    MAX_RECENT_SEARCHES_TO_STORE_IN_THE_LOCAL_STORAGE,
    GLOBAL_SEARCH_NAVIGATION_STATE_KEY,
    GLOBAL_SEARCH_DEFAULT_ACTIVE_CATEGORY
};